import { action } from 'satcheljs';
import Message from 'owa-service/lib/contract/Message';

/**
 * Action to remove suppress read receipt from the message
 */
export default action('removeSuppressReceiptFromItem', (message: Message) => ({
    message,
}));
